import store from "../store";
import Constants from "../config/constants";
import { serviceCreateHealthCare, serviceGetHealthCare } from "../services/HealthCare.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_HEALTH_CARE";
export const FETCHED = "FETCHED_HEALTH_CARE";
export const FETCHED_FAIL = "FETCHED_FAIL_HEALTH_CARE";
export const FETCHED_FILTER = "FETCHED_FILTER_HEALTH_CARE";
export const NEXT_PREQUESTS = "NEXT_PREQUESTS";
export const PREV_PREQUESTS = "PREV_PREQUESTS";
export const FETCH_NEXT = "FETCH_NEXT_HEALTH_CARE";
export const FILTER = "FILTER_HEALTH_CARE";
export const RESET_FILTER = "RESET_FILTER_HEALTH_CARE";
export const SET_SORTING = "SET_SORTING_HEALTH_CARE";
export const SET_FILTER = "SET_FILTER_HEALTH_CARE";
export const SET_PAGE = "SET_PAGE_HEALTH_CARE";
export const CHANGE_PAGE = "CHANGE_PAGE_HEALTH_CARE";
export const CHANGE_STATUS = "CHANGE_STATE_HEALTH_CARE";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_HEALTH_CARE";
export const CREATE_DATA = "CREATE_HEALTH_CARE";
export const UPDATE_DATA = "UPDATE_HEALTH_CARE";
export const DELETE_ITEM = "DELETE_HEALTH_CARE";
export const PERMISSION = "PERMISSION";

export function actionFetchHealthCare(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetHealthCare({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateContact(data) {
    const request = serviceCreateHealthCare(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved', type: 'success'});
                dispatch({type: CREATE_DATA, payload: data.data})
            }
        })
    }
}

export function actionChangePageHealthCare(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function nextPRequestsClick() {
  return {
    type: NEXT_PREQUESTS,
    payload: null,
  };
}

export function actionFilterHealthCare(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusHealthCare(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterHealthCare() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageHealthCare(page) {
  const stateData = store.getState().health_care;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchHealthCare(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
